import { Marker } from 'react-leaflet';

// One click (or Enter) on a hazard marker selects the storm; the card, the footprint and the fit to the storm all
// follow from the selection. Leaflet reports Enter as 'keypress' when no popup is bound, so it is handled here.
export default function HazardEventMarker({ event, icon, title, onSelect }) {
  const handleKey = (e) => {
    if (e.originalEvent?.key === 'Enter' || e.originalEvent?.keyCode === 13) onSelect(event);
  };
  return (
    <Marker
      position={[event.lat, event.lng]}
      icon={icon}
      title={title}
      eventHandlers={{ click: () => onSelect(event), keypress: handleKey }}
    />
  );
}
